<template>
    <views>
        <nav-bar
            title="意见反馈"
            fixed
            @click-left="onClickLeft">
        </nav-bar>

        <views class="feedback">
            <views class="feedback-banner">
                <images :src="bannerImg"></images>
            </views>
            <views class="feedback-des">
                <views class="main-title">中国-阿拉伯化肥服务理念：</views>
                <views class="main-title">一切以顾客为中心</views>
                <views class="sub-title">对我们的产品和服务有什么建议和意见，请填写下面表单后点击发送给我们，我们将以不断改进的产品和服务作为对您的回报。</views>
            </views>
            <views class="feedback-content">
                <views class="feedback-list">
                    <views class="feedback-label">主题</views>
                    <views class="feedback-value">
                        <input type="text" placeholder="请输入" v-model="form.topic">
                    </views>
                </views>
                <views class="feedback-list">
                    <views class="feedback-label">联系人</views>
                    <views class="feedback-value">
                        <input type="text" placeholder="请输入" v-model="form.contact">
                    </views>
                </views>
                <views class="feedback-list">
                    <views class="feedback-label">联系电话</views>
                    <views class="feedback-value">
                        <input type="text" placeholder="请输入" v-model="form.phone">
                    </views>
                </views>
                <!-- <views class="feedback-list">
                    <views class="feedback-label">您想说的</views>
                    <views class="feedback-value">
                        <input type="text" placeholder="请输入" v-model="form.content">
                    </views>
                </views> -->
                <views class="feedback-textarea">
                    <textarea v-model="form.content" placeholder="请输入您想说的..." rows="4"></textarea>
                </views>
                <views class="feedback-list">
                    <button class="primary" @click="submitFeedback">提交</button>
                </views>
            </views>
            <views class="feedback-wx">
                <images :src="contactImg"></images>
            </views>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
import storage from '@/utils/storage'
export default {
    components: {
        NavBar
    },
    mixins: [tools],
    data() {
        return {
            form: {},
            bannerList: [],
            contactImg: require('@/assets/images/contact_wx.png')
        }
    },
    computed: {
        bannerImg() {
            return this.bannerList[0] && this.bannerList[0].url
        },
        member() {
            return JSON.parse(storage.get('member'))
        }
    },
    created() {
        this.setBaseInfo()
    },
    mounted() {
        this.setBgColor()
        this.getBanner()
    },
    destroyed() {
        this.resetBgColor()
    },
    methods: {
        onClickLeft() {
            this.back()
        },
        setBaseInfo() {
            this.form.contact = this.member.nick_name
            this.form.phone = this.member.mobile
        },
        submitFeedback() {
            const { topic, contact, phone, content } = this.form
            if (!topic) return this.notify('请输入主题')
            if (!contact) return this.notify('请输入联系人')
            if (!phone) return this.notify('请输入联系电话')
            if (!content) return this.notify('请输入你想说的内容')
            const params = { ...this.form }
            api.submitFeedback(params).then((res) => {
                if (res.code === 0) {
                    this.sucMsg('提交成功')
                    this.push('/person')
                } else {
                    this.notify('提交失败')
                }
            })
        },
        getBanner() {
            api.getBanner({ position_type: 3 }).then((res) => {
                if (res.data.list) {
                    this.bannerList = res.data.list
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
